import { createContext } from "react";
import type { FormValue, FormValues } from "../../common/types/formTypes";

export const FormContext = createContext({
   updateFormValues: <T,>(_value: FormValue<T>) => {},
   registerField: <T,>(_value: FormValue<T>) => {},
   unregisterField: (_value: string) => {},
   isFormValid: true,
   formValues: {} as FormValues
});
